<template name="inprogress">
  <div class="progressList" :class="{'remove-item': this.newDeviceLayout}">
    <div class="progress-list"  v-if="progressData.length && !this.newDeviceLayout">
      <div class="view-header row">
        <h4 class="col-5">邀请进度</h4>
        <div v-on:click="toggleProgress" class="col-7 btn-toggle-train" v-if="progressData.length > 5">
          <span v-show="!showProgress">更多<i class="iconfont icon-down"></i></span>
          <span v-show="showProgress">收起<i class="iconfont icon-up"></i></span>
        </div>
      </div>
      <div class="view-content">
        <ul>
          <li class="row" :class="showProgress == true ? 'isShow' : '' "" v-if="index<5" v-for="(item, index) in progressData">
            <div class="col-6">{{ item.createTime }}</div>
            <div class="col-6 message">{{ item.message }}</div>
          </li>
          <li class="row" v-show="showProgress" v-if="index>4" v-for="(item, index) in progressData">
            <div class="col-6">{{ item.createTime }}</div>
            <div class="col-6 message">{{ item.message }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="progress-list" :class="{'remove-item': this.newDeviceLayout}" v-if="progressData.length && this.newDeviceLayout">
      <div class="view-header row" :class="{'remove-item': this.newDeviceLayout, 'remove-item-padding': this.showProgress}">
        <h4 class="col-5">邀请进度</h4>
        <div v-on:click="toggleProgress" class="col-7 btn-toggle-train">
          <span v-show="!showProgress">更多<i class="iconfont icon-down"></i></span>
          <span v-show="showProgress">收起<i class="iconfont icon-up"></i></span>
        </div>
      </div>
      <div class="view-content">
        <ul>
          <li class="row" v-show="showProgress"  v-for="(item, index) in progressData">
            <div class="col-6">{{ item.createTime }}</div>
            <div class="col-6 message">{{ item.message }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { securityGetInvitationSchedule } from '@/utils/api';
  import { checkNested } from '@/utils/utils';
  export default {
    name: '',
    props: {
      routId: String,
      newDeviceLayout: Boolean,
    },
    watch: {
      routId(newValue, oldValue) {
        console.log(newValue,oldValue);
       this.invitationId = newValue;
       this.comment(this.invitationId);
      }
    },
    created() {
      // progress
      this.comment(this.routId)
    },
    data() {
      return {
        showProgress: false,
        progressData: [],
        invitationId: '',
      }
    },
    methods: {
      comment(routId) {
        securityGetInvitationSchedule(routId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          this.progressData = res.data.content.model;
        }
      });
      },
      toggleProgress: function() {
        this.showProgress = !this.showProgress;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .progressList {
    width: 290px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.1);
    &.remove-item {
      width: 100%;
    }
  }
  .progress-list {
    width: 100%;
    margin: 0 auto;
    padding: 20px;
    color: #4a4a4a;
    margin-bottom: 70px;
    margin-top: 20px;
    &.remove-item {
      margin-bottom: 20px;
      li:nth-of-type(5) {
        padding-bottom: 25px;
      }
    }
    .btn-toggle-train {
      cursor: pointer;
      text-align: right;
      font-size: 13px;
      padding-right: 25px;
      i {
        font-size: 12px;
        display: inline-block;
        transform: scale(0.75, 0.75);
        margin-left: 5px;
        margin-right: -5px;
      }
    }
    .view-header {
      align-items: center;
      &.remove-item {
        h4 {
          margin-bottom: 0;
        }
        &.remove-item-padding {
          padding-bottom: 15px;
        }
      }
      h4 {
        font-size: 16px;
        margin-bottom: 15px; 
      }
    }
    .view-content {
      padding: 0;
    }
    ul {
      padding: 0;
      list-style: none;
      position: relative;
      &:before {
        content: '';
        width: 2px;
        background: #cecece;
        display: block;
        position: absolute;
        top: 6px;
        left: 0;
        height: calc(100% - 12px);
      }
      .isShow:nth-of-type(5) {
        padding-bottom: 25px;
      }
    }
    li {
      padding-left: 24px;
      position: relative;
      font-size: 12px;
      line-height: 1;
      padding-bottom: 25px;
      &:nth-of-type(5) {
        padding-bottom: 0;
      }
      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 10px;
        display: block;
        background: #999;
      }
      &:before {
        width: 12px;
        height: 12px;
        border-radius: 6px;
        opacity: 0.18;
      }
      &:after {
        width: 6px;
        height: 6px;
        border-radius: 3px;
        top: 3px;
        left: 13px;
        transform: scale(0.9,0.9);
      }
      &:first-child {
        color: #e42029;
        &:before,
        &:after {
          background: #ff2137;
        }
      }
      &:last-child {
        padding-bottom: 0;
      }
      .message {
        text-align: right;
        line-height: 18px;
        word-break: break-all;
      }
    }
  }
</style>
